import { dateTimeString, formatDeveui } from "./../../utils/filters";
import { strings } from "../../services/Localization";
import { DEVEUI_INPUT_VALIDATION, ID_INPUT_VALIDATION } from "./DataTable/DataTableConsts";
import { ColumnType } from "./DataTable/DataTypes";


type PartialColumnType = Omit<ColumnType, 'type'> & Partial<Pick<ColumnType, keyof ColumnType>>;



export function generateGatewayColumn(column: PartialColumnType): ColumnType {
  return {
    ...column,

    key: column.key ?? 'id',
    dbKey: column.dbKey,
    title: column.title ?? strings.GATEWAY_ID,
    type: column.type ?? 'text',

    width: column.width ?? 160,
    minWidth: column.minWidth ?? 160,
    maxWidth: column.maxWidth ?? 160,
    newCellWidth: column.newCellWidth ?? '180px',
    flex: column.flex ?? 1,
    detailPageNav: column.detailPageNav,

    sortable: column.sortable ?? true,
    filterable: column.filterable ?? true,
    filterField: column.filterField ?? 'search_id',
    filterType: 'text',
    filterParams: column.filterParams ?? {
      mapper: (x: string) => (x || '').replace(/[-:]/g, '')
    },

    inputValidation: column.inputValidation ?? ID_INPUT_VALIDATION,
    detailLink: column.detailLink ?? true,
    showCopyLink: column.showCopyLink ?? true,
    copyLink: column.copyLink ?? true,
    customClass: column.customClass ?? 'font-monospace left',
  };
}


export function generateDateTimeColumn(column: PartialColumnType): ColumnType {
    return {
        ...column,
        key: column.key ?? 'starttmst',
        dbKey: column.dbKey,
        title: column.title ?? strings.TABLE_NST_START_DATE,
        type: column.type ?? 'text',  
        width: column.width ?? 180,
        minWidth: column.minWidth ?? 180,
        maxWidth: column.maxWidth ?? 180,   
        render: column.render ?? ((row) => dateTimeString(row[column.key])),
        sortable: column.sortable ?? false,
        sortKey: column.sortKey ?? "sort_by_timestamp",
        
        filterType: column.filterType ?? 'daterange',
        filterable: column.filterable ?? false,
        filterField: 'date',
        filterParams: column.filterParams ?? {
                startField: "from_date",
                endField: "to_date",
                mapper: (x) => x && x.format()
        },
        defaultFilterValue: column.defaultFilterValue ?? [],
        newCellWidth: column.newCellWidth ?? '180px',
        flex: column.flex ?? 1,
        customClass: column.customClass ?? 'font-monospace left',
    };
}

export function generateDevEUIcolumn(column: PartialColumnType): ColumnType {
  return {
    ...column,
    key: column.key ?? 'deveui',
    title: column.title ?? strings.DEVEUI,
    type: column.type ?? 'text',
    maxInputLength: column.maxInputLength ?? 40,
    width: column.width ?? 210,
    minWidth: column.minWidth ?? 210,
    maxWidth: column.maxWidth ?? 210,
    newCellWidth: column.newCellWidth ?? '200px',
    render: column.render ?? ((row) => formatDeveui(row[column.key])),
    flex: column.flex ?? 1,
    detailPageNav: column.detailPageNav,
    sortable: column.sortable ?? true,
    sortKey: column.sortKey ?? 'sort_by_deveui',
    filterable: column.filterable ?? true,
    filterField: column.filterField ?? 'search_deveui',
    filterType: 'text',
    filterParams: {
      mapper: x => (x || "").replace(/[-:\s]/g, "").toLowerCase()
    },
    inputValidation: column.inputValidation ?? DEVEUI_INPUT_VALIDATION,
    detailLink: column.detailLink ?? true,
    showCopyLink: column.showCopyLink ?? true,
    copyLink: column.copyLink ?? true,
    customClass: column.customClass ?? 'font-monospace left',
  };
} 

